import axiosClient from './axios';

// GET
const getMatch = async (jobId, joinData, search, progress, page, recordPerPage) => {
  return axiosClient.post(`/v1/match/get`, {
    jobCode: jobId,
    joinData: [joinData, 'job'],
    search: search,
    progress: progress,
    page: page,
    recordPerPage: recordPerPage,
  });
};

const getMatchEmployer = async (jobId, joinData, search, status, page, recordPerPage, matchCode, sort) => {
  return axiosClient.post(`/v1/employer/match/get`, {
    jobCode: jobId,
    search: search,
    status: status,
    role: joinData,
    page: page,
    recordPerPage: recordPerPage,
    matchCode: matchCode ?? '',
    [sort['field']]: sort['order'] ?? '',
  });
};
const getMatchOne = async (matchId) => {
  return axiosClient.get(`/v1/match/getOne?code=${matchId}`);
};
const matchHistory = async (maskId) => {
  return axiosClient.get(`/v1/matchHistory/getAll?code=${maskId}`);
};
const getMatchMore = async (param) => {
  try {
    let endpoint = `/v1/admin/account/listing?userRole=${param?.role || 'freelancer'}&jobCode=${param?.jobCode}`;
    if (param?.professional) {
      endpoint += `&professional=${param?.professional === 'QC' ? 'Quality Controller' : param?.professional}`;
    }
    if (param?.experienceLevel) {
      if (Array.isArray(param?.experienceLevel)) {
        endpoint += `&experienceLevel=${(param?.experienceLevel || []).join(',')}`;
      } else {
        endpoint += `&experienceLevel=${param?.experienceLevel}`;
      }
    }
    if (param?.search) {
      endpoint += `&search=${param?.search}`;
    }
    if (param?.filter) {
      endpoint += `&experienceLevel=["${param?.filter}"]`;
    }
    return axiosClient.get(endpoint);
  } catch (error) {}
};
const getMatchCount = async (param) => {
  return axiosClient.get(`/v1/match/getCount?jobCode=${param}`);
};
// PUT
const updateStatus = async (maskId, status, invited) => {
  return axiosClient.put(`/v1/match/update`, {
    matchCode: maskId,
    message: 'Selected the application',
    subject: 'Talent Manager',
    status: status,
    interviewInviteted: invited,
  });
};

// POST
const insertHistory = async (maskCode, status, message, object = 'admin') => {
  return axiosClient.post(`/v1/matchHistory`, {
    message,
    status,
    subject: 'Talent Manager',
    object,
    matchCode: maskCode,
    refType: 'interview',
  });
};

const getApplicationMatch = async (matchId) => {
  return axiosClient.get(`/v1/application/get/${matchId}`);
};

const sendRequestMatchMore = async (data) => {
  return axiosClient.post(`/v1/match/request`, data);
};

export {
  getMatch,
  getMatchEmployer,
  updateStatus,
  matchHistory,
  insertHistory,
  getMatchMore,
  getMatchCount,
  getMatchOne,
  getApplicationMatch,
  sendRequestMatchMore,
};
